import { memo } from 'react';

import { PlusIcon } from '@air/design-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';

export type AssetMobileVersionsHeaderProps = {
  onCreate?: IconButtonProps['onClick'];
  title?: string;
};

export const AssetMobileVersionsHeader = memo(({ onCreate, title = 'Versions' }: AssetMobileVersionsHeaderProps) => {
  return (
    <header className="flex items-center justify-between gap-2">
      <h3 className="font-bold ads:text-primary text-12 text-gray-12 uppercase tracking-wider">{title}</h3>

      {onCreate && (
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          icon={PlusIcon}
          label="Add new version"
          onClick={onCreate}
          size="small"
        />
      )}
    </header>
  );
});

AssetMobileVersionsHeader.displayName = 'AssetMobileVersionsHeader';
